import * as OFMSUI from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Field, useFormik, FormikProvider, ErrorMessage } from "formik";
import * as Yup from "yup";
import React, { useState } from "react";
import { Form } from "react-bootstrap";
import HousingService from "../../../Services/HousingService";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import { DashboardServiceReport, ExportToExcelButton, generatePDF, GetDetails, LabelHeader, ModuleHeader, todayDate } from "../../utils/commonFunctions";
import { store } from "../../../App";
import ShowAlert from "../../alert";
import { Table } from "react-bootstrap"; import { AiOutlineSearch } from "react-icons/ai";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import moment from "moment-timezone";

const BankACAsperEnteries = () => {
  const [bankNamesList, setbankNamesList] = useState([]);
  const [brsData, setbrsData] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [search, setSearch] = useState("");



  const validationSchema = Yup.object().shape({
    bankname: Yup.string().required("required"),
    fromdate: Yup.string().required("required"),
    todate: Yup.string().required("required"),

  });
  const formik = useFormik({
    initialValues: {
      bankname: "",
      fromdate: "",
      todate: ""
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      let params = { brsBanknameaccountno: values.bankname, brsFromDate: moment(values.fromdate).format("DD/MM/YYYY"), brsToDate: moment(values.todate).format("DD/MM/YYYY") }
      store.dispatch({ type: "SHOW_SPINNER" });
      HousingService.getBankACAsperEnteries(params).then((res) => {
        if (res && res.data && res.data?.length > 0) {
          setbrsData(res.data);
        }
        else {
          setbrsData([]);
        }
      }).catch((error) => {
        ShowAlert("Some error occured", "error");
        console.log(error);
      }).finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
        setShowTable(true);
      })
    }
  });

  React.useEffect(() => {
    HousingService.fetchBank().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          if (item !== null) {
            return (
              <option key={i} value={item.banknameaccountno}> {item.banknameaccountno} </option>
            );
          }
        });
        setbankNamesList(options);
      }
    });
  }, []);
  const handleSearch = event => { setSearch(event.target.value) }

  const filteredData = search.length > 0 ? brsData?.filter((item) => {
    return (
      item && Object.keys(item).some((key) => {
        const value = item[key];
        return (
          value !== null && value.toString().toLowerCase().includes(search.toLowerCase()));
      }));
  }) : brsData;






  return (
    <>
      <NavigationServicesHeader />
      <ModuleHeader title="Bank Statement as per PassBook Report" />
      <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "90%" }}>
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <DashboardServiceReport title="Service" />
            <OFMSUI.Row className="mb-3">
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="" > <LabelHeader title="From date" /> <Field type="date" max={todayDate} name="fromdate" className={formik.touched.fromdate && formik.errors.fromdate ? "form-control is-invalid" : "form-control"} />  <ErrorMessage name="fromdate" component={"div"} className="text-error" /> </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="" > <LabelHeader title="To date" /> <Field type="date" max={todayDate} name="todate" className={formik.touched.todate && formik.errors.todate ? "form-control is-invalid" : "form-control"} /> <ErrorMessage name="todate" component={"div"} className="text-error" /></OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="" > <LabelHeader title="Bank" /> <Field component="select" name="bankname" className={formik.touched.bankname && formik.errors.bankname ? "form-control is-invalid" : "form-control"} > <option value="">Select</option> {bankNamesList} </Field> <ErrorMessage name="bankname" component={"div"} className="text-error" /> </OFMSUI.Col>
              <GetDetails />
            </OFMSUI.Row>

            {showTable && (
              <>
                <OFMSUI.Row> <OFMSUI.Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=' mb-3' > <div className='input-group'> <div className='input-group-prepend'> <div className='input-group-text group_txt11' id='btnGroupAddon' > <AiOutlineSearch /> </div> </div> <input type='text' id='#filterInput' placeholder='Search ' style={{ width: '25%' }} className='form-control input-lg' value={search} onChange={handleSearch} ></input> </div> </OFMSUI.Col>
                  <OFMSUI.Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9} className=' mb-2 float-end' >
                    <ExportToExcelButton tableId="my-table" filename="BankACAsperEnteries" sheet="tablexls" buttonText="Excel" />
                    <button className='btn btn-danger btn-sm' type='button' style={{ float: 'right', marginLeft: '3px' }}
                      onClick={() => generatePDF("my-table", "Bank Statement as per PassBook Report", "BankACAsperEnteries.pdf", 5)}> PDF <MdOutlinePictureAsPdf /> </button>
                  </OFMSUI.Col>
                </OFMSUI.Row>
                <div style={{ overflow: "auto", height: "500px" }}>
                  <Table striped bordered hover id="my-table" style={{ width: "100%" }}>
                    <thead className="fw-bold" style={{ top: "0px", position: "sticky" }}>
                      <tr style={{backgroundColor:"#f2f2f2"}}><th className="text-center" colSpan={6}><h6>Bank Statement as per PassBook Report from {moment(formik.values.fromdate).format("DD-MM-YYYY")} to {moment(formik.values.todate).format("DD-MM-YYYY")} of Bank A/C No: {formik.values.bankname}</h6></th></tr>
                      <tr className="table_countshead">
                        <th className="text-center">S No.</th>
                        <th>Date</th>
                        <th style={{ width: "50%" }}>Particulars</th>
                        <th className="text-center">Debit</th>
                        <th className="text-center">Credit</th>
                        <th className="text-center">Balance</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData?.length === 0 || filteredData === undefined ? (
                        <tr>
                          <td colSpan={6} style={{ fontSize: "15px", textAlign: "center" }}>
                            No details found
                          </td>
                        </tr>
                      ) : (
                        <>
                          {/* <tr> <td colSpan={3} style={{ textAlign:"center", fontWeight: "bold" }}> Banlance as per PassBook : </td> <td className="text-right">{filteredData[0]?.debit}</td> <td className="text-right">{filteredData[0]?.credit}</td> <td></td> </tr> */}
                          {filteredData.map((detail, i) => (
                            <tr key={i}>
                              <td className="text-center">{i + 1}</td>
                              <td>{moment(detail?.date).format("DD-MM-YYYY")}</td>
                              <td>{detail?.remarks}</td>
                              <td className="text-right">{detail?.debit}</td>
                              <td className="text-right">{parseFloat(detail?.credit).toFixed(2)}</td>
                              <td className="text-right">{parseFloat(detail?.balance).toFixed(2)}</td>
                            </tr>
                          ))}
                        </>
                      )}
                    </tbody>
                    <tfoot>
                      <tr className="table_countshead" >
                        <td className="text-right"  colSpan={3}>Total Amount in Rs/-</td>
                        <td className="text-right" >{filteredData?.reduce((a, b) => a + parseFloat(b.debit), 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                        <td className="text-right" >{filteredData?.reduce((a, b) => a + parseFloat(b.credit), 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                        <td></td>
                      </tr>
                    </tfoot>'


                  </Table>
                </div>


              </>
            )}




          </Form>
        </FormikProvider>
      </OFMSUI.Container>
    </>
  )
}

export default BankACAsperEnteries
